import React, { useState, useContext } from 'react';
import ThemeContext from '../context/theme.Context';
import LoadingContext from '../context/loading.context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-router-dom";
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Spinner from './Spinner.component';
import * as Constants from '../modules/constants';


function ForgotPassword() {

    const { showLoading, hideLoading } = useContext(LoadingContext);

    const [validated, setValidated] = useState(false);
    const [email, setEmail] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [resetLinkSent, setResetLinkSent] = useState(false);
    const [resetFailed, setResetFailed] = useState(false);

    const apiHostName = Constants.API_URL;

    function handleSubmit(event) {

        event.preventDefault();

        // Check form validation
        const form = event.currentTarget;
        setValidated(true);
        setButtonDisabled(true);

        if (form.checkValidity() === false) {
            // Invalid form, so stop processing
            event.stopPropagation();
            setButtonDisabled(false);
            return;
        }

        // Request server to send password reset link:
        showLoading();
        fetch(apiHostName + '/v1/users/forgotPassword/' + encodeURIComponent(email), {
            mode: "cors",
            method: 'POST',
            cache: "no-cache"
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network error');
                }
                return response.text();
            })
            .then((result) => {
                // Result contains a text message that the action was successful - ignore this...
                hideLoading();
                setResetLinkSent(true);
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on registration screen
                console.error("Cannot reset password...");
                console.error(error);
                setResetFailed(true);
                setResetLinkSent(true);
                hideLoading();
            });
    }

    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <Row style={{ justifyContent: 'center' }}>
                    <div className="login-card">
                        <div style={{ justifyContent: 'center', display: 'flex' }}>
                            <div className="brand_logo_container">
                                <img src="icon.svg" className="brand_logo" alt="Logo" />
                            </div>
                        </div>

                        <div className="form-container">
                            <Form.Group className="form-title">
                                <div>Forgot password</div>
                            </Form.Group>
                            {!resetLinkSent &&
                                <React.Fragment>
                                    <div style={{ marginBottom: '12px', color: '#ffffff' }}>
                                        Please enter your e-mail address to have a password reset link be sent to.
                                </div>
                                    <Form noValidate validated={validated} onSubmit={(event) => { handleSubmit(event); }}>
                                        <Form.Group controlId="formEmail">
                                            <InputGroup>
                                                <span className="input-group-text"><FontAwesomeIcon icon="envelope" /></span>
                                                <Form.Control type="email" name="Email" placeholder="E-mail address" value={email} onChange={(e) => { setEmail(e.target.value); }} required />
                                                <Form.Control.Feedback type="invalid">
                                                    <div className="control-feedback" style={{ color: '#ffffff' }}>Please fill in your e-mail address.</div>
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group>
                                            <Button className="login-button" disabled={buttonDisabled} type="submit">Reset password <Spinner /></Button>
                                        </Form.Group>
                                    </Form>
                                </React.Fragment>
                            }
                            {resetLinkSent &&
                                <div className="bottom-links">
                                    {resetFailed &&
                                        <div>A reset password link cannot currently be sent. Please try again later.</div>
                                    }
                                    {!resetFailed &&
                                        <div>If {email} is a valid user account, a reset password link has just been sent.</div>
                                    }
                                <div className="bottom-links">Go <Link to="/login">back</Link> to the login screen.</div>
                                </div>
                            }
                        </div>
                    </div>
                </Row>
            )}
        </ThemeContext.Consumer>
    );
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js